import { createStore } from "vuex";
import { getLoginData, getUserInfoData } from '@/api/home'

const mutations = {
  SET_POSSIBLE_DATA(state: { possibleData: object; }, data: { possibleData: object; }) {
    state.possibleData = data;
  },
  SET_ACCESSTOKEN(state: { accessToken: string; }, accessToken: string) {
    state.accessToken = accessToken;
  },
  SET_OPENID(state: { openid: string; }, openid: string) {
    state.openid = openid;
  },
  SET_USERINFO(state: { userInfo: object; }, data: { userInfo: object; }) {
    state.userInfo = data;
  },
};

const state = {
  possibleData: {},
  accessToken: '',
  openid: '',
  userInfo: {}
};

const actions = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  GetLoginDatas({ commit }:any, code: string) {
    return new Promise((resolve, reject) => {
      const newsTarget = {
        code: code,
        deptName: process.env.VUE_APP_BASE_SITE
      }
      getLoginData(newsTarget).then(res => {
        const { accessToken, openid } = res.data
        localStorage.setItem('accessToken', accessToken)
        localStorage.setItem('openid', openid)
        commit('SET_ACCESSTOKEN', accessToken)
        commit('SET_OPENID', openid)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  GetUserInfo({ commit }:any, openid: string) {
    return new Promise((resolve, reject) => {
      const newsTarget = {
        openid: openid
      }
      const accessToken = localStorage.getItem('accessToken')
      getUserInfoData(newsTarget).then(res => {
        const { data } = res.data
        commit('SET_USERINFO', data)
        commit('SET_ACCESSTOKEN', accessToken)
        commit('SET_OPENID', openid)
        localStorage.setItem('nickname', data.nickname)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default createStore({
  state,
  getters: {},
  mutations,
  actions,
  modules: {},
});
